import React, { type FC } from 'react';
import { DashboardBody } from './components/DashboardBody';
import { DashboardJumbotron, DashboardJumbotronSkeleton } from './components/DashboardJumbotron';
import { sortToDos } from 'components/ToDos';
import { useTranslation } from 'react-i18next';
import { PageMetadata } from 'components/Shared/PageMetadata';
import { useQuery } from '@apollo/client';
import { TODO_QUERY } from 'components/ToDos/queries';
import { type ProviderData, useAuth } from 'components/Auth';
import CredentialingProvider from 'components/ProviderProfile/components/Tabs/Credentialing/CredentialingProvider';
import { useIsTraumaCounsellor } from 'components/CriticalIncident/hooks/useIsTraumaCounsellor';

import './Dashboard.scss';

interface DashboardProps { }

export const Dashboard: FC<DashboardProps> = (_) => {
    const { t, ready } = useTranslation('common', { useSuspense: false });
    const { effectiveProviderData = {} as ProviderData } = useAuth();
    const { isTraumaOnlyCounsellor, loading: loadingContractedServices } = useIsTraumaCounsellor(effectiveProviderData?.providerId!);

    const toDosQuery = useQuery(TODO_QUERY, {
        variables: {
            providerId: effectiveProviderData!.providerId
        },
        skip: loadingContractedServices || isTraumaOnlyCounsellor
    });
    
    const toDos = toDosQuery.data?.toDos;

    const filteredToDos = toDos?.filter(todo => todo.visibility);
    const sortedToDos = sortToDos(filteredToDos);

    return (
        <React.Fragment>
            { ready && 
                <PageMetadata 
                pageDescription={t('page_description')} 
                pageTitle={t('page_title')}
                /> 
            }
            <div className="dashboard_container">
                {loadingContractedServices ? <DashboardJumbotronSkeleton /> : !isTraumaOnlyCounsellor && <DashboardJumbotron toDos={sortedToDos} loading={toDosQuery.loading}/>}
                <CredentialingProvider providerId={effectiveProviderData?.providerId}>
                    <DashboardBody toDos={sortedToDos} loading={toDosQuery.loading || loadingContractedServices}/>
                </CredentialingProvider>
            </div>
        </React.Fragment>
    )
}